<app-lista-de-pessoas-view [IsFornecedor]="true"></app-lista-de-pessoas-view>
